<app-header></app-header>

<div class="container-fluid" style="width: 80%">
    <div class="row mt-4 mb-4">
        <div class="col">
            <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
                <ol class="breadcrumb mb-0 p-0">
                    <li class="breadcrumb-item">
                        <a href="/home">Home</a><span class="separator">/</span>
                    </li>
                    <li class="breadcrumb-item">
                        <a href="/richieste">Cruscotto richieste</a><span class="separator">/</span>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        Dettaglio richiesta
                    </li>
                </ol>
            </nav>
        </div>
    </div>

    <div class="row mt-4 mb-4">
        <div class="col">
            <h4>Dettaglio richiesta</h4>
        </div>
    </div>

    <div class="row">
        <mat-tab-group animationDuration="0ms">
            <mat-tab label="Dati richiesta">
                <div class="mt-4">
                    <!-- Griglia 2x2: Richiesta, Inviante, Setting, Dati medici -->
                    <div class="row g-3 mb-4">
                        <div class="col-md-6">
                            <mat-card appearance="outlined" class="h-100">
                                <mat-card-header>
                                    <mat-card-title><b>Richiesta</b></mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <p class="mb-0">
                                        <b>Id rich. SI-COT:</b> {{ richiesta?.id }}<br />
                                        <b>Id rich. esterno:</b>
                                        <span *ngIf="richiesta?.identifierSystem || richiesta?.identifierValue">
                                            {{ richiesta?.identifierValue || richiesta?.identifierSystem || '-' }}<span
                                                *ngIf="richiesta?.identifierSystem && richiesta?.identifierValue"> ({{
                                                richiesta.identifierSystem }})</span>
                                        </span>
                                        <span *ngIf="!richiesta?.identifierSystem && !richiesta?.identifierValue">{{
                                            richiesta?.idRichiestaEsterno || '-' }}</span>
                                        <br />
                                        <b>Data arrivo:</b> {{ richiesta?.dataOraRichiesta | date : "dd/MM/yyyy"
                                        }}<br />
                                        <b>Alert:</b> {{ richiesta?.alert || '-' }}
                                    </p>
                                </mat-card-content>
                            </mat-card>
                        </div>
                        <div class="col-md-6">
                            <mat-card appearance="outlined" class="h-100">
                                <mat-card-header>
                                    <mat-card-title><b>Inviante</b></mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <p class="mb-0">
                                        <b>S.I. Inviante:</b> {{ richiesta?.siInviante || '-' }}<br />
                                        <b>Struttura inviante:</b> {{ richiesta?.strutturaInviante || '-' }}<br />
                                        <b>Centrale COT collegata:</b> {{ richiesta?.centraleCOT || '-' }}
                                    </p>
                                </mat-card-content>
                            </mat-card>
                        </div>
                        <div class="col-md-6">
                            <mat-card appearance="outlined" class="h-100">
                                <mat-card-header>
                                    <mat-card-title><b>Setting</b></mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <p class="mb-0">
                                        <b>Setting proposto:</b> {{ richiesta?.settingProposto || '-' }}<br />
                                        <b>Setting definitivo:</b> {{ richiesta?.settingDefinitivo || '-' }}<br />
                                        <b>Richiedi UVM:</b> {{ (richiesta?.uvm?.descrizione ?? richiesta?.uvm?.codice)
                                        || '-' }}<br />
                                        <b>Data accesso registrata:</b> {{ richiesta?.dataAccesso ?
                                        (richiesta.dataAccesso | date : "dd/MM/yyyy") : '-' }}
                                    </p>
                                </mat-card-content>
                            </mat-card>
                        </div>
                        <div class="col-md-6">
                            <mat-card appearance="outlined" class="h-100">
                                <mat-card-header>
                                    <mat-card-title><b>Dati medici</b></mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <p class="mb-0">
                                        <b>Patologie prevalenti:</b>
                                        <ng-container
                                            *ngIf="richiesta?.patologiePrevalenti?.length; else singlePatologia">
                                            <ul class="mb-2 mt-1">
                                                <li *ngFor="let p of richiesta.patologiePrevalenti">
                                                    {{ p.display || p.code || '-' }}<span *ngIf="p.system || p.code">
                                                        ({{ p.system }}: {{ p.code }})</span>
                                                </li>
                                            </ul>
                                        </ng-container>
                                        <ng-template #singlePatologia>
                                            <span>{{ richiesta?.descrizionePatologiaPrevalente ||
                                                richiesta?.codicePatologiaPrevalente || '-' }}<span
                                                    *ngIf="richiesta?.codicePatologiaPrevalente"> ({{
                                                    richiesta.codicePatologiaPrevalente }})</span></span>
                                        </ng-template>
                                        <b>Sintomi clinici:</b>
                                        <ng-container *ngIf="richiesta?.sintomi?.length; else singleSintomo">
                                            <ul class="mb-2 mt-1">
                                                <li *ngFor="let s of richiesta.sintomi">
                                                    {{ s.display || s.code || '-' }}<span *ngIf="s.system || s.code">
                                                        ({{ s.system }}: {{ s.code }})</span>
                                                </li>
                                            </ul>
                                        </ng-container>
                                        <ng-template #singleSintomo>
                                            <span>{{ richiesta?.descrizioneSintomo || richiesta?.codiceSintomoClinico ||
                                                '-' }}<span *ngIf="richiesta?.codiceSintomoClinico"> ({{
                                                    richiesta.codiceSintomoClinico }})</span></span>
                                        </ng-template>
                                        <b>Assistenza infermieristica:</b>
                                        <span *ngIf="richiesta?.assistenzaInfermieristica"
                                            class="badge bg-success ms-1">SI</span>
                                        <span *ngIf="!richiesta?.assistenzaInfermieristica"
                                            class="badge bg-danger ms-1">NO</span>
                                        <br />
                                        <b>Note assistenza infermieristica:</b> {{
                                        richiesta?.noteAssistenzaInfermieristica || '-' }}
                                    </p>
                                </mat-card-content>
                            </mat-card>
                        </div>
                    </div>

                    <!-- Card a tutta larghezza: Note + Stampa -->
                    <mat-card appearance="outlined" class="mb-4">
                        <mat-card-content
                            class="d-flex flex-wrap align-items-center justify-content-between gap-3 py-3">
                            <div class="flex-grow-1">
                                <b>Note richiesta:</b>
                                <ul class="ps-3 mb-0">
                                    <li *ngFor="let noteRich of richiesta?.noteRichiesta">
                                        {{ noteRich.testo || '-' }}
                                    </li>
                                </ul>
                                <b>Note accesso:</b> {{ richiesta?.noteAccesso || '-' }}
                            </div>
                            <div class="d-flex align-items-center gap-2">
                                <button mat-raised-button color="primary" [disabled]="generazioneAllegatoInCorso"
                                    (click)="generaAllegato(richiesta)">
                                    <mat-icon>picture_as_pdf</mat-icon>
                                    Stampa riepilogo richiesta
                                </button>
                                <mat-progress-bar *ngIf="generazioneAllegatoInCorso" mode="indeterminate"
                                    style="width: 120px;"></mat-progress-bar>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </mat-tab>

            <mat-tab label="Allegati richiesta">
                <ng-container *ngIf="!caricamento">
                    <mat-card appearance="outlined" class="mt-4 mb-4">
                        <mat-card-header>
                            <mat-card-title><b>Allegati</b></mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <div class="m-3">
                                <table mat-table [dataSource]="dataSourceAllegati" multiTemplateDataRows>
                                    <ng-container matColumnDef="icon">
                                        <th mat-header-cell *matHeaderCellDef></th>
                                        <td mat-cell *matCellDef="let sel">
                                            <mat-icon matListItemIcon>folder</mat-icon>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="tipo">
                                        <th mat-header-cell *matHeaderCellDef>Tipo</th>
                                        <td mat-cell *matCellDef="let sel">
                                            {{ sel.tipo }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="contenuto">
                                        <th mat-header-cell *matHeaderCellDef>Contenuto</th>
                                        <td mat-cell *matCellDef="let sel">
                                            <button disabled="{{downloadAllegatoInCorso.state}}" (click)="scarica(sel)"
                                                mat-button>
                                                <mat-spinner *ngIf="getDownloadAllegatoInCorso(sel)"
                                                    [diameter]="30"></mat-spinner>
                                                <a *ngIf="!getDownloadAllegatoInCorso(sel)">APRI</a>
                                            </button>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="descrizione">
                                        <th mat-header-cell *matHeaderCellDef>Descrizione</th>
                                        <td mat-cell *matCellDef="let sel">
                                            {{ sel.descrizione }}
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

                                    <tr class="mat-row" *matNoDataRow>
                                        <td class="mat-cell no-results-row" [attr.colspan]="displayedColumns.length">
                                            Nessun risultato.
                                        </td>
                                    </tr>
                                </table>

                            </div>
                        </mat-card-content>
                    </mat-card>
                </ng-container>
            </mat-tab>

            <mat-tab label="Sessione UVM" *ngIf="showSessioneUVM">
                <app-sessione-uvm [idRichiesta]="idRichiesta"></app-sessione-uvm>
            </mat-tab>

            <mat-tab label="Esito UVM" *ngIf="showEsitoUVM">
                <app-esito-uvm [idRichiesta]="idRichiesta"></app-esito-uvm>
            </mat-tab>

            <mat-tab label="PDE" *ngIf="showPDE">
                <mat-card appearance="outlined" class="mt-4 mb-4">
                    <mat-card-header>
                        <mat-card-title><b>Riepilogo</b></mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="m-3">

                            <table mat-table matSort [dataSource]="this.interventoIniziale" multiTemplateDataRows>
                                <ng-container matColumnDef="tipoIntervento">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        Tipo intervento
                                    </th>
                                    <td mat-cell *matCellDef="let sel">
                                        {{ sel?.tipoIntervento?.descrizione }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="tipoOperatore">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        Tipo operatore
                                    </th>
                                    <td mat-cell *matCellDef="let sel">
                                        {{ sel?.tipoOperatore?.descrizione }}
                                    </td>
                                </ng-container>



                                <ng-container matColumnDef="operatore">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        Operatore (inviante)
                                    </th>
                                    <td mat-cell *matCellDef="let sel">

                                        {{ sel?.operatore?.cognome}} {{ sel?.operatore?.nome}}
                                    </td>
                                </ng-container>


                                <ng-container matColumnDef="strutturaRiferimento">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        Struttura riferimento
                                    </th>
                                    <td mat-cell *matCellDef="let sel">
                                        <div *ngIf="sel?.strutturaRiferimento?.parentDetails">
                                            <strong>Struttura padre:</strong>
                                            {{sel?.strutturaRiferimento?.parentDetails.oid_2}} -
                                            {{sel?.strutturaRiferimento?.parentDetails.codice}} -
                                            {{sel?.strutturaRiferimento?.parentDetails.descrizione}}<br>
                                        </div>
                                        {{ sel?.strutturaRiferimento?.denominazione }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="frequenza">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        Frequenza
                                    </th>
                                    <td mat-cell *matCellDef="let sel">{{ sel.frequenza }}</td>
                                </ng-container>

                                <ng-container matColumnDef="attivita">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        Attività
                                    </th>
                                    <td mat-cell *matCellDef="let sel">

                                        <div *ngFor="let attivita of  sel.attivita ">
                                            - {{ attivita.descrizione }} ({{ attivita.codice }})<br>

                                        </div>

                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumnsInterventoPaziente"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsInterventoPaziente"></tr>
                                <tr class="mat-row" *matNoDataRow>
                                    <td class="mat-cell no-results-row"
                                        [attr.colspan]="displayedColumnsInterventoPaziente.length">
                                        Nessun risultato.
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </mat-card-content>
                </mat-card>
            </mat-tab>
        </mat-tab-group>
    </div>

    <div class="row">
        <div class="col">
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title><b>Paziente</b></mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <p>
                        <b>Nome: </b>{{ paziente?.nome }}<br />
                        <b>Cognome: </b>{{ paziente?.cognome }}<br />
                        <b>Codice Fiscale: </b>{{ paziente?.codiceFiscale }}<br />
                        <ng-container
                            *ngIf="paziente?.indirizzoResidenza || paziente?.comuneResidenza || paziente?.provinciaSiglaResidenza">
                            <b>Residenza: </b>
                            <span *ngIf="paziente?.indirizzoResidenza">{{ paziente?.indirizzoResidenza }}<span
                                    *ngIf="paziente?.comuneResidenza || paziente?.provinciaSiglaResidenza">,
                                </span></span>
                            <span *ngIf="paziente?.comuneResidenza">{{ paziente?.comuneResidenza }}</span><span
                                *ngIf="paziente?.comuneResidenza && paziente?.provinciaSiglaResidenza"> </span><span
                                *ngIf="paziente?.provinciaSiglaResidenza">({{ paziente?.provinciaSiglaResidenza
                                }})</span>
                        </ng-container>
                        <ng-container
                            *ngIf="paziente?.indirizzoDomicilio || paziente?.comuneDomicilio || paziente?.postalCodeDomicilio || paziente?.countryDomicilio">
                            <br />
                            <b>Domicilio: </b>
                            <span *ngIf="paziente?.indirizzoDomicilio">{{ paziente?.indirizzoDomicilio }}<span
                                    *ngIf="paziente?.comuneDomicilio || paziente?.postalCodeDomicilio || paziente?.provinciaSiglaDomicilio">,
                                </span></span>
                            <span *ngIf="paziente?.comuneDomicilio">{{ paziente?.comuneDomicilio }}</span><span
                                *ngIf="paziente?.comuneDomicilio && paziente?.provinciaSiglaDomicilio"> </span><span
                                *ngIf="paziente?.provinciaSiglaDomicilio">({{ paziente?.provinciaSiglaDomicilio
                                }})</span><span *ngIf="paziente?.postalCodeDomicilio"> {{ paziente?.postalCodeDomicilio
                                }}</span><span *ngIf="paziente?.countryDomicilio"> {{ paziente?.countryDomicilio
                                }}</span>
                        </ng-container>
                    </p>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button (click)="openDialog(paziente)">
                        <span class="badge rounded-pill bg-secondary">i</span>
                    </button>
                </mat-card-actions>
            </mat-card>
        </div>
        <div class="col">
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title><b>Operatore inviante</b></mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <p>
                        <b>Nome: </b>{{ operatore?.nome }}<br />
                        <b>Cognome: </b>{{ operatore?.cognome }}<br />
                        <b>Codice Fiscale: </b>{{ operatore?.codiceFiscale }}<br />
                        <b>Qualifica/e: </b>{{ getQualificheText(operatore) }}
                    </p>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button (click)="openDialog(operatore)">
                        <span class="badge rounded-pill bg-secondary">i</span>
                    </button>
                </mat-card-actions>
            </mat-card>
        </div>
        <div class="col">
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title><b>Richiedente</b></mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <p>
                        <b>Cognome: </b>{{ richiedente?.cognome }}<br />
                        <b>Nome: </b>{{ richiedente?.nome }}<br />
                        <b>Codice Fiscale: </b>{{ richiedente?.codiceFiscale }}<br />
                        <b>Qualifica: </b>{{ richiedente?.qualifica }}<br />
                    </p>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button (click)="openDialog(richiedente)">
                        <span class="badge rounded-pill bg-secondary">i</span>
                    </button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>

    <div class="row mt-4 mb-4">
        <div class="col">
            <ng-container *ngIf="!caricamento">
                <app-gestione-richiesta [idRichiesta]="this.idRichiesta"
                    (valueChanged)="refreshState($event)"></app-gestione-richiesta>
            </ng-container>
        </div>
    </div>
</div>

<app-footer></app-footer>